import LoginPage from "../pages/auth/LoginPage";
import LiveClasses from "../pages/liveClass/LiveClasses";
import RecordedClasses from "../pages/pastSession/RecordedClasses";
import DoubtSession from "../pages/askDoubt/DoubtSession";
import Report from "../pages/viewReport/Report";
import Calendar from "../pages/calendar/Calendar";
import HomePage from "../pages/home/HomePage";
import PlayerPage from "../pages/player/PlayerPage";

import { FaVideo, FaCalendarAlt, FaBook, FaUser, FaBell } from "react-icons/fa";

export const routes = [
  { path: "/login", element: <LoginPage />, public: true, },
  { path: "/home-page", element: <HomePage />, public: true, },
  { path: "/player", element: <PlayerPage />, public: true, },
  { path: "/", redirect: "/live-classes", public: true, },
  { path: "/live-classes", element: <LiveClasses />, title: "Live Class", icon: FaVideo, showInSidebar: true, public: true, role: ["admin", "teacher", "student"], },
  { path: "/recorded-session", element: <RecordedClasses />, title: "Past Sessions", icon: FaCalendarAlt, showInSidebar: true, public: true, role: ["teacher", "student"], },
  { path: "/report", element: <Report />, title: "View Report", icon: FaBook, showInSidebar: true, public: true, role: ["teacher", "student"], },
  { path: "/doubt-session", element: <DoubtSession />, title: "Ask Doubt", icon: FaUser, showInSidebar: true, public: true, role: ["teacher", "student"], },
  { path: "/calendar", element: <Calendar />, title: "Calendar", icon: FaCalendarAlt, showInSidebar: true, public: true, role: ["teacher", "student"], },
];